// Ubicación en el repo: src/components/BackupSettings.jsx
// Sub-pestaña "Backup" de Configuración (DECISIONS.md #62). Contenido
// informativo, no ejecuta nada — el backup real corre desde la terminal de
// un Admin, con la service_role key de Supabase, que nunca puede vivir en
// el navegador (mismo motivo por el que todos los scripts/*.mjs se corren
// así). Esta pantalla es la versión "para leer en la app" de BACKUP.md en
// la raíz del repo, para no tener que ir a buscar el archivo cada vez.
// La URL del proyecto no es secreta (ya viaja en el HTML/JS del sitio, es
// pública por diseño de Supabase) — se toma de la misma variable de entorno
// que usa supabaseClient.js, para no repetirla a mano y que quede siempre
// correcta si el proyecto cambia alguna vez.
const PROJECT_URL = import.meta.env.VITE_SUPABASE_URL;

function CodeBlock({ children }) {
  return <pre className="mono code-block">{children}</pre>;
}

export default function BackupSettings() {
  return (
    <div className="patients-page">
      <h1>Backup</h1>

      <p className="field-hint" style={{ marginBottom: 16 }}>
        El proyecto se mantiene en el plan Free de Supabase por ahora, que no incluye backups automáticos.
        Mientras eso no cambie, el resguardo es manual — estos son los pasos. Se recomienda hacerlo una vez
        por semana como mínimo (por ejemplo, los sábados al cierre), y siempre antes de un cambio importante
        en el sistema.
      </p>

      <div className="card-panel" style={{ marginBottom: 14 }}>
        <h3 style={{ marginTop: 0 }}>Paso 1 — Backup de los datos (pacientes, citas, exámenes, etc.)</h3>
        <p className="field-hint">
          Abrí una terminal (Git Bash) en la carpeta del proyecto y corré, reemplazando{' '}
          <code className="mono">tu-secret-key</code> por la clave secreta del dashboard de Supabase
          (Settings → API → Secret keys, o service_role) y la fecha por la de hoy:
        </p>
        <CodeBlock>{`SUPABASE_URL=${PROJECT_URL} \\
SUPABASE_SERVICE_ROLE_KEY=tu-secret-key \\
node scripts/backup-database.mjs ./backups/AAAA-MM-DD/backup-datos`}</CodeBlock>
      </div>

      <div className="card-panel" style={{ marginBottom: 14 }}>
        <h3 style={{ marginTop: 0 }}>Paso 2 — Backup de los archivos (firmas, adjuntos, logos)</h3>
        <p className="field-hint">Mismo lugar, mismo tipo de clave:</p>
        <CodeBlock>{`SUPABASE_URL=${PROJECT_URL} \\
SUPABASE_SERVICE_ROLE_KEY=tu-secret-key \\
node scripts/backup-storage.mjs ./backups/AAAA-MM-DD/backup-storage`}</CodeBlock>
      </div>

      <div className="card-panel" style={{ marginBottom: 14 }}>
        <h3 style={{ marginTop: 0 }}>Paso 3 — Guardarlo</h3>
        <p className="field-hint">
          La carpeta <code className="mono">backups/</code> ya está excluida de Git (no se sube a GitHub), así
          que podés dejar los resultados ahí mismo. Si querés un resguardo a más largo plazo, copiá esa carpeta
          a otro lugar de tu computadora de vez en cuando.
        </p>
      </div>

      <p className="field-hint">
        La clave secreta nunca debe pegarse en ningún otro lugar (ni compartirse por correo o chat) — solo se
        usa en tu propia terminal, en el momento de correr el comando. Nunca va en el repositorio ni en esta
        pantalla.
      </p>

      <p className="field-hint">
        Para restaurar todo en un proyecto nuevo (si algún día hace falta), o para ver el detalle completo del
        proceso, está documentado en <code className="mono">BACKUP.md</code> en la raíz del repositorio.
      </p>
    </div>
  );
}
